<section class="ei-popup enable-popup-wrapper">
  <form class="ei-popup-form" #f="ngForm" #form novalidate>
    <p style="background-color: #f2f542; width: fit-content;">{{ fieldsAreFullError }}</p>
    <div class="row row-margin">
      @if (!isEdit || (isEdit && editableObj?.Field_Type)) {
      <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 margin-bottom-1">
        <label
          >Field Type@if (!isEdit) {
          <span><b class="text-danger">*</b></span>
          }</label
        >
        @if (isSystemAdmin && !isEdit) {
        <mat-form-field appearance="outline" class="custom-dropdown">
          <input style="border:none;width:100%" class="edit text-notavailable-option option-size" />
          <mat-select
            placeholder="Select Field Type"
            (selectionChange)="fieldValueChanges()"
            name="field_type"
            [(ngModel)]="fieldType"
            required
          >
            @for (fType of fieldTypeOptions; track fType) {
            <mat-option class="roleDropdownList" [value]="fType">
              <ng-container>{{ fType }}</ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if (isAdmin && !isSystemAdmin && !isEdit) {
        <span>
          <p class="edit-defaults">Initiative</p>
        </span>
        } @if (isEdit) {
        <span>
          <p class="edit-defaults">{{ fieldType }}</p>
        </span>
        }
      </div>
      } @if (!isEdit || (isEdit && editableObj?.column_name)) {
      <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 margin-bottom-1">
        <label
          >Column Name<span><b class="text-danger">*</b></span>
          <span style="color: #0000007a; font-weight: 100;">(upto 50 characters)</span></label
        >
        <mat-form-field class="custom-dropdown" appearance="outline">
          <input
            (input)="fieldValueChanges('columnName')"
            [(ngModel)]="columnName"
            name="columnName"
            matInput
            type="text"
            maxlength="50"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
        @if (isColNameExst) {
        <div class="help-block uitk-c-input__message--error">
          Column name already exists!
        </div>
        } @if (limitExceedColName) {
        <div class="help-block uitk-c-input__message--error">
          Only 50 characters allowed in Column Name
        </div>
        } @if (columnName?.length!=50) {
        <div
          class="help-block uitk-c-input__message--error"
          style="background-color:green;width: 100%; padding-top: 0; padding-bottom: 0;"
        >
          <span> {{ 50 - columnName?.length }} Char Left </span>
        </div>
        } @if (limitExceedColName) {
        <div class="help-block uitk-c-input__message--error">
          0 Char Left
        </div>
        }
      </div>
      } @if (!isEdit || (isEdit && editableObj?.input_type)) {
      <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 margin-bottom-1">
        <label
          >Input Type<span><b class="text-danger">*</b></span></label
        >
        <mat-form-field appearance="outline" class="custom-dropdown">
          <input style="border:none;width:100%" class="edit text-notavailable-option option-size" />
          <mat-select
            placeholder="Select Input Type"
            (selectionChange)="fieldValueChanges()"
            name="input_type"
            [(ngModel)]="inputType"
            required
          >
            @for (iType of inputTypeOptions; track iType) {
            <mat-option class="roleDropdownList" [value]="iType">
              <ng-container>{{ iType | titlecase }}</ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      } @if (!isEdit || (isEdit && editableObj?.data_type)) {
      <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 margin-bottom-1">
        <label
          >Data Type<span><b class="text-danger">*</b></span> @if (inputType == 'input') {
          <span><b class="text-danger">*</b></span>
          }</label
        >
        <mat-form-field appearance="outline" class="custom-dropdown">
          <input
            style="border:none;width:100%"
            class="edit text-notavailable-option option-size"
            [disabled]="disableDataType"
          />
          <mat-select
            placeholder="Select Data Type"
            name="data_type"
            (selectionChange)="fieldValueChanges()"
            [(ngModel)]="dataType"
            [required]="inputType == 'input'"
            [disabled]="disableDataType"
            required
          >
            @for (dType of dataTypeOptions; track dType) {
            <mat-option class="roleDropdownList" [value]="dType">
              <ng-container>{{ dType }}</ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      } @if (!isEdit || (isEdit && editableObj?.length)) {
      <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 d-flex margin-bottom-1">
        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 no-leftPadding">
          <label
            >Length@if (dataType == 'String' && isSystemAdmin) {
            <span><b class="text-danger">*</b></span>
            }</label
          >
          @if (isSystemAdmin) {
          <mat-form-field class="custom-dropdown" appearance="outline">
            <input
              name="lengthControl"
              type="number"
              (input)="fieldValueChanges()"
              [(ngModel)]="length"
              matInput
              type="text"
              [disabled]="!isSystemAdmin"
              onkeydown="if(event.key==='.'){event.preventDefault();}"
              [required]="dataType == 'String' && isSystemAdmin"
            />
          </mat-form-field>
          } @if (isAdmin && !isSystemAdmin) {
          <span>
            <p class="edit-defaults">{{ length }}</p>
          </span>
          }
        </div>
      </div>
      } @if (!isEdit || (isEdit && editableObj?.Visible)) {
      <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 d-flex margin-bottom-1 no-RightPadding">
        <label class="margin-right-1"
          >Visible<span><b class="text-danger">*</b></span></label
        >
        <mat-radio-group
          class="margin-top-2 d-flex position-absolute"
          (change)="fieldValueChanges('visible')"
          [(ngModel)]="visible"
          name="visible"
          required
        >
          <mat-radio-button class="margin-ryt-1" color="primary" value="Yes" [disabled]="isVisibleFieldDisabled"
            >Yes</mat-radio-button
          >
          <mat-radio-button color="primary" value="No" [disabled]="isVisibleFieldDisabled">No</mat-radio-button>
        </mat-radio-group>
      </div>
      } @if (!isEdit || (isEdit && (editableObj?.Editable || editableObj?.Bulk_required))) {
      <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 d-flex margin-bottom-1">
        @if (!isEdit || (isEdit && editableObj?.Editable)) {
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6 d-flex no-leftPadding">
          <label class="margin-right-1"
            >Editable<span><b class="text-danger">*</b></span></label
          >
          <mat-radio-group
            class="margin-top-2 d-flex position-absolute"
            (change)="fieldValueChanges()"
            [(ngModel)]="editable"
            name="editable"
            [disabled]="visible == 'No'"
            required
          >
            <mat-radio-button class="margin-ryt-1" color="primary" value="Yes">Yes</mat-radio-button>
            <mat-radio-button color="primary" value="No">No</mat-radio-button>
          </mat-radio-group>
        </div>
        } @if (!isEdit || (isEdit && editableObj?.Bulk_required)) {
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6 d-flex no-rightPadding">
          <label class="margin-right-1"
            >Bulk Required<span><b class="text-danger">*</b></span></label
          >
          <mat-radio-group
            class="d-flex position-absolute margin-top-2"
            (change)="fieldValueChanges()"
            [(ngModel)]="bulkRequired"
            name="bulkRequired"
            [disabled]="visible == 'No'"
            required
          >
            <mat-radio-button class="margin-ryt-1" color="primary" value="Yes">Yes</mat-radio-button>
            <mat-radio-button color="primary" value="No">No</mat-radio-button>
          </mat-radio-group>
        </div>
        }
      </div>
      }
      <div class="col-md-1 col-sm-1 col-lg-1 col-xl-1 col-xs-1 d-flex margin-bottom-1 no-leftPadding">
        @if ((!isEdit && isSystemAdmin) || (isEdit && editableObj?.Modify_UI)) {
        <div>
          <label class="margin-right-1"
            >Modify UI<span><b class="text-danger">*</b></span></label
          >
          <mat-radio-group
            class="mt-2 d-flex position-absolute"
            (change)="fieldValueChanges('visible')"
            [(ngModel)]="modifyUI"
            name="modifyUI"
            required
          >
            <mat-radio-button class="margin-ryt-1" color="primary" value="Yes">Yes</mat-radio-button>
            <mat-radio-button color="primary" value="No">No</mat-radio-button>
          </mat-radio-group>
        </div>
        }
      </div>
      @if (!isEdit || (isEdit && editableObj?.Edit_Roles)) {
      <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 margin-bottom-1">
        <label
          >Edit Roles<span><b class="text-danger">*</b></span></label
        >
        <mat-form-field appearance="outline" class="custom-dropdown">
          <input style="border:none;width:100%" class="edit text-notavailable-option option-size" />
          <mat-select
            placeholder="Select Edit Roles"
            name="edit_roles"
            (selectionChange)="fieldValueChanges()"
            [selected]="selectedRoles"
            [(ngModel)]="editRoles"
            multiple
            required
          >
            @for (role of editRolesOptions; track role) {
            <mat-option class="roleDropdownList" [value]="role">
              <ng-container>{{ role }}</ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      } @if (!isEdit || (isEdit && editableObj?.allowed_values)) {
      <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6 chipset-wrapper margin-bottom-1">
        <label
          >Allowed Values<span><b class="text-danger">*</b></span></label
        >
        <mat-form-field class="example-chip-list chip-fields" appearance="outline">
          <mat-chip-grid #chipList class="allowed-values-chip-list font-size-1">
            @for (chip of allowedValues; track chip) {
            <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="remove(chip)">
              {{ chip }}
              @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
              }
            </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            matInput
            [(ngModel)]="newAllowedValues"
            name="allowedValues"
            [matChipInputFor]="chipList"
            (matChipInputTokenEnd)="add($event)"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            style=" height: auto; width: 100% !important; margin: 0px; border-bottom: black 1px solid !important;"
            [placeholder]="disableAllowedValues ? '' : 'Enter an Allowed Value here and then press Enter'"
            [disabled]="disableAllowedValues"
          />
        </mat-form-field>
      </div>
      }
      <!-- </div> -->
      <!-- <div class="row margin-top-1 row-margin"> -->
      <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6 margin-bottom-1">
        <div class="description-block">
          <label
            >Description<span><b class="text-danger">*</b></span>
            <span style="color: #0000007a; font-weight: 100;">(upto 3000 characters)</span></label
          >
          <p class="m-0">
            <textarea
              (input)="focusDes(); fieldValueChanges()"
              rows="5"
              type="textarea"
              class="form-control textarea-class"
              name="Description"
              [(ngModel)]="description"
              required
              minlength="3"
              maxlength="3000"
              [ngModelOptions]="{ standalone: true }"
              (input)="fieldValueChanges()"
            ></textarea>
          </p>
          @if (limitExceedDesc) {
          <div class="help-block uitk-c-input__message--error">
            Only 3000 characters allowed in Description
          </div>
          } @if (limitExceedDesc) {
          <div class="help-block uitk-c-input__message--error">
            0 Char Left
          </div>
          } @if (description?.length!=3000) {
          <div
            class="help-block uitk-c-input__message--error"
            style="background-color:green; width: 100%; padding-top: 0; padding-bottom: 0;"
          >
            <span> {{ 3000 - description?.length }} Char Left </span>
          </div>
          }
        </div>
      </div>
      <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
        <span class="category-new">
          <p class="category-headers">
            Category<span><b class="text-danger">*</b></span>
          </p>

          @if (!newCategoryClicked) {
          <button
            (click)="newCategory()"
            mat-mdc-raised-button
            class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
          >
            Create New
          </button>
          } @if (newCategoryClicked) {
          <button
            (click)="newCategory()"
            mat-mdc-raised-button
            class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
          >
            Existing Category
          </button>
          }
        </span>

        @if (!newCategoryClicked) {
        <mat-form-field [floatLabel]="'never'" class="add-dropdown category-border">
          <input class="category-new-dropdown edit text-notavailable-option option-size" />
          <mat-select
            [(ngModel)]="AddCategoryDataUpdated.category"
            (selectionChange)="categoryChange($event)"
            name="category"
            [selected]="AddCategoryDataUpdated.category"
            placeholder="Select a Category"
            required
          >
            @for (category of categories; track category) {
            <mat-option class="dropDownList" [value]="category?.categoryName">
              <ng-container>
                {{ category?.categoryName }}
              </ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if (newCategoryClicked) {
        <input
          (input)="disableApplyAddCategory()"
          [(ngModel)]="AddCategoryDataUpdated.category"
          Placeholder="Enter a Category"
          name="category"
          class="category-newCategory category-add-input category-border"
        />
        }
      </div>
      <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
        <span class="category-new">
          <p class="category-headers">
            Category Default State<span><b class="text-danger">*</b></span>
          </p>
        </span>
        <mat-form-field class="add-dropdown category-border">
          <input class="category-new-dropdown edit text-notavailable-option option-size" />
          <mat-select
            [(ngModel)]="AddCategoryDataUpdated.categoryDefaultState"
            (selectionChange)="categoryDefaultStateChange($event)"
            name="categoryState"
            [selected]="AddCategoryDataUpdated.categoryDefaultState"
            placeholder="Select a Category Default State"
            required
          >
            @for (categoryState of categoryDefaultState; track categoryState) {
            <mat-option class="dropDownList" [value]="categoryState">
              <ng-container>
                {{ categoryState }}
              </ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (!isEdit || (isEdit && editableObj?.SubCategory)) {
      <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
        <span class="category-new">
          <p class="category-headers">Sub Category</p>
          @if (!newSubCategoryClicked) {
          <button
            (click)="newSubCategory()"
            mat-mdc-raised-button
            class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
          >
            Create New
          </button>
          } @if (newSubCategoryClicked) {
          <button
            (click)="newSubCategory()"
            mat-mdc-raised-button
            class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
          >
            Existing Category
          </button>
          }
        </span>
        @if (!newSubCategoryClicked) {
        <mat-form-field [floatLabel]="'never'" class="add-dropdown category-border">
          <input class="category-new-dropdown edit text-notavailable-option option-size" />
          <mat-select
            [(ngModel)]="AddCategoryDataUpdated.subCategory"
            (selectionChange)="subCategoryChange($event)"
            name="subCategory"
            [selected]="AddCategoryDataUpdated.subCategory"
            placeholder="Select a Sub Category"
          >
            @for (subCategory of subCategoryOptions; track subCategory) {
            <mat-option class="dropDownList" [value]="subCategory">
              <ng-container>
                {{ subCategory }}
              </ng-container>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if (newSubCategoryClicked) {
        <input
          (input)="disableApplyAddSubCategory()"
          [(ngModel)]="AddCategoryDataUpdated.subCategory"
          Placeholder="Enter a Sub Category"
          name="subCategory"
          class="category-newCategory category-add-input category-border"
        />
        }
      </div>
      }
    </div>
  </form>
  <div class="pull-right subLob-edit-apply me-3 margin-top-1">
    <button
      mat-mdc-raised-button
      type="submit"
      [disabled]="
        f.invalid ||
        !columnName ||
        !description ||
        (!isEdit && allowedValues?.length == 0) ||
        (isEdit && fieldType == 'Initiative' && allowedValues?.length == 0) ||
        (newCategoryClicked && !AddCategoryDataUpdated?.category) ||
        (isEdit && !isDataUpdated) ||
        isColNameExst
      "
      (click)="onSubmit(f)"
      class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
    >
      Submit
    </button>
  </div>
  @if (showLoader) {
  <div class="stk-table-loader bulk-loader">
    <app-loader> </app-loader>
  </div>
  }
</section>
